import type { User } from "@supabase/supabase-js";

/** Supabase anonymous sign-in users should not appear as "logged in" in the UI. */
export function getAuthenticatedUser(user: User | null | undefined): User | null {
  if (!user || user.is_anonymous) {
    return null;
  }
  return user;
}

export const AUTH_SKIP_ANONYMOUS_KEY = "auth_skip_anonymous";

export function setSkipAnonymousSession(skip: boolean): void {
  if (skip) {
    sessionStorage.setItem(AUTH_SKIP_ANONYMOUS_KEY, "1");
  } else {
    sessionStorage.removeItem(AUTH_SKIP_ANONYMOUS_KEY);
  }
}

export function shouldSkipAnonymousSession(): boolean {
  return sessionStorage.getItem(AUTH_SKIP_ANONYMOUS_KEY) === "1";
}
